module.exports = __webpack_public_path__ + "media/images/flags/1x1/nfk-3561f0fb717e305437400050bdc4642c.svg";